<template>
  <div class="text-center">
    <client-loader :client-id="account.clientId" v-model="client" />
    <div class="row q-col-gutter-y-md">
      <div class="col-12 col-sm-4">
        <div class="text-h5">
          <post-count :filters="{ accountIds: [this.account.id]}" />
        </div>
        <div class="text-body1 text-uppercase">Total Posts</div>
      </div>
      <div v-if="until" class="col-12 col-sm-4">
        <div class="text-h5">
          <post-count :filters="{ accountIds: [this.account.id], until }" />
        </div>
        <div class="text-body1 text-uppercase">Pre Date of Loss</div>
      </div>
      <div v-if="since" class="col-12 col-sm-4">
        <div class="text-h5">
          <post-count :filters="{ accountIds: [this.account.id], since }" />
        </div>
        <div class="text-body1 text-uppercase">Post Date of Loss</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';
import { Account } from '@/social/types';
import PostCount from '@/social/post/util/PostCount.vue';
import ClientLoader from '@/client/ClientLoader.vue';
import moment from 'moment';

interface Data {
  client: Client|null
}

export default defineComponent({
  components: {
    ClientLoader,
    PostCount,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      client: null,
    };
  },
  computed: {
    since(): string|null {
      return this.client ? this.client.dateOfLoss : null;
    },
    until(): string|null {
      if (!this.client) return null;
      const dateOfLoss = moment(this.client.dateOfLoss);
      dateOfLoss.subtract(1, 'day');
      return dateOfLoss.format('YYYY-MM-DD');
    },
  },
});
</script>
